/*

Controller file for Leases

*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { useCallback } from 'react';

var Properties = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getProperties: function(sortId, callback) {
		var self = this;
        if(sortId != 0) {
		    var url = "properties/sort/" + sortId;
        } else {
		    var url = "properties";
        }
		var data = self.server.getData(url, null, true);
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(response.data.length == 0) {
                response.data = null;
            }

			callback(response);
		})
		.fail(function(e){
			modal.showInfo(e.statusText, "danger", "top", "center");
		});
	}
});

export let properties = new Properties();


// WEBPACK FOOTER //
// app/core/controllers/Properties.js